export class NumberHelper {

    public static MaxValue = 2147483647;

}

